import { UpdatedChatStatusSocket } from "../entities/UpdatedChatStatusSocket";
import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class OnUpdatedChatStatus {
	constructor(private repository: ChatSocketRepository) {}

	execute(callback: (data: UpdatedChatStatusSocket) => void): void {
		return this.repository.onUpdatedChatStatus(callback);
	}
}
